<h2 class="mb-5">{{ 'COMMON.CANDIDATES' | translate }} >> {{ 'COMMON.ADD' | translate }}</h2>

<div class="card mb-4 border-0 shadow-sm">
  <div class="card-body">
    <form [formGroup]="candidateForm" (ngSubmit)="onSubmit()">
      <div class="form-row justify-content-center">
        <div class="form-group">
          <label for="email">{{ 'COMMON.EMAIL' | translate }}*</label>
          <input type="email" class="form-control" id="email" formControlName="email">
          <ct-control-messages [control]="candidateForm.get('email')"></ct-control-messages>
        </div>

        <div class="form-group">
          <label for="documentType">{{ 'COMMON.TYPE' | translate | titlecase }} {{ 'COMMON.DOCUMENT' | translate }}</label>
          <select class="form-control" id="documentType" formControlName="documentType" (change)="documentTypeChange()">
            <option value="idCard">{{ 'COMMON.IDCARD' | translate }}</option>
            <option value="passport">{{ 'COMMON.PASSPORT' | translate }}</option>
          </select>
          <ct-control-messages [control]="candidateForm.get('documentType')"></ct-control-messages>
        </div>

        <div class="form-group">
          <label for="idCard">{{ 'COMMON.DOCUMENT' | translate }}</label>
          <input type="text" class="form-control" id="idCard" formControlName="idCard">
          <ct-control-messages [control]="candidateForm.get('idCard')"></ct-control-messages>
        </div>

        <div class="form-group">
          <label for="name">{{ 'COMMON.NAME' | translate }}*</label>
          <input type="text" class="form-control" id="name" formControlName="name">
          <ct-control-messages [control]="candidateForm.get('name')"></ct-control-messages>
        </div>

        <div class="form-group">
          <label for="surname1">{{ 'COMMON.SURNAME' | translate }} 1*</label>
          <input type="text" class="form-control" id="surname1" formControlName="surname1">
          <ct-control-messages [control]="candidateForm.get('surname1')"></ct-control-messages>
        </div>

        <div class="form-group">
          <label for="surname2">{{ 'COMMON.SURNAME' | translate }} 2</label>
          <input type="text" class="form-control" id="surname2" formControlName="surname2">
          <ct-control-messages [control]="candidateForm.get('surname2')"></ct-control-messages>
        </div>

        <div class="form-group">
          <label>&nbsp;</label>
          <button type="submit" class="btn btn-primary form-control" [disabled]="candidateForm.invalid" [ngbTooltip]="('COMMON.SAVE' | translate)">
            <i class="fa fa-save"></i>
          </button>
        </div>
      </div>
    </form>

  </div>
</div>
